module.exports = __webpack_public_path__ + "static/media/icomoon.ab101445.svg";